import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneEditCustomer = _resolveComponent("VabeneEditCustomer");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('pages.editCustomer') || 'Éditer Client'
        }, null, 8, ["PageTitle"]),
        _createVNode(_component_VabeneEditCustomer, { customerID: _ctx.customerID }, null, 8, ["customerID"])
    ], 64));
}
